// extracted by mini-css-extract-plugin
export var attachmentContainer = "_f2-0";
export var fileList = "_f2-2";
export var removeFileButton = "_f2-1";